// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@ces/App/Components/Notify";
import dataTableStyles from "@ces/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { recentOrdersStyles } from "@ces/Overrides/Widgets/Common/RecentOrders";
import CartFilled from "@ces/XDL/Icons/CartFilled";
import LinkArrowRight from "@ces/XDL/Icons/LinkArrowRight";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color, ellipsis, mergeWithCss, xScreen } from "@ces/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

recentOrdersStyles.cardList = {
    gridContainer: {
        gap: 0,
    },
};

recentOrdersStyles.noOrdersFoundText = {
    ...mergeWithCss(getNotifyStyle("info", true), {
        css: css`
            margin: 0;
        `,
    }),
};

recentOrdersStyles.dataTable = {
    ...dataTableStyles.dataTable,
};

recentOrdersStyles.dataTableHead = {
    css: css`
        line-height: 13px;
    `,
};

recentOrdersStyles.actionsTableHeaders = {
    css: css`
        width: 112px;
    `,
};

recentOrdersStyles.noOrdersFoundGridItem = {
    width: 12,
    css: css`
        text-align: center;
        padding: 0;
    `,
};
recentOrdersStyles.shipToTableHeaders = {
    css: css`
        min-width: 230px;
    `,
};

recentOrdersStyles.titleTypographyStyles = {
    wrapper: {
        css: css`
            justify-content: space-between;
            align-items: flex-end;
            flex-wrap: wrap;
            margin-bottom: 16px;

            ${xScreen("lte", "md")} {
                flex-direction: row;
                align-items: baseline;
            }

            ${xScreen("lt", "sm")} {
                flex-direction: column;
            }
        `,
    },
    title: {
        variant: "h3",
        color: "text.main",
    },
    linkWithArrow: {
        typographyProps: {
            size: 12,
            weight: fontConfig.weight.bold,
            css: css`
                letter-spacing: 0;
                line-height: 15px;
            `,
        },
        icon: {
            iconProps: {
                src: LinkArrowRight,
                color: "text.link",
                css: css`
                    height: 13px;
                    width: 11px;
                `,
            },
            position: "right",
        },
    },
    link: {
        typographyProps: {
            size: 12,
            css: css`
                line-height: 15px;
            `,
        },
    },
};

recentOrdersStyles.orderSummaryCard = {
    actionsCells: {
        css: css`
            padding: 7px 10px;
        `,
    },
    dataTableRow: {
        css: css`
            td[class^="DataTableCellBase"] {
                line-height: 22px;
            }
        `,
    },
    shipToCells: {
        css: css`
            ${ellipsis(1)}
        `,
    },
    reorderButton: {
        css: css`
            max-width: 112px;
            color: ${color("common.white")};
            ${IconWrapper} {
                width: 11px;
                height: 13px;
                color: ${color("common.white")};
                top: 0;
            }
        `,
        icon: {
            src: CartFilled,
            position: "left",
        },
    },
};
